
        var result = require("!!../../../../node_modules/css-loader/index.js!./personalsettings.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/personalsettings/personalsettings.component.css
// module id = 722
// module chunks = 0